module.exports = __webpack_public_path__ + "static/media/chevron-double-up.e9c0845e.svg";